import { CSSProperties } from 'react';
import { Link } from 'react-router';
import { Box, Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { UserProfession } from '~/enums/UserProfession';
import { IProfessionalCardUser } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';
import { getTruncatedNameStyle } from '../shared/cardText';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** marginLeft has no DS Box prop (spaces this column from the avatar in the parent card) */
const detailsColumnStyle: CSSProperties = { marginLeft: 24 };
/** 2px vertical divider; DS Box has no background prop */
const dividerStyle: CSSProperties = { backgroundColor: colors.neutral['600'] };
/** strip the default anchor underline around the DS Typography */
const profileLinkStyle: CSSProperties = { textDecoration: 'none' };
/** textTransform has no DS Typography prop */
const capitalizeStyle: CSSProperties = { textTransform: 'capitalize' };

interface IProfessionalCardDetailsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetails = ({ user }: IProfessionalCardDetailsProps) => {
  const { id, isAvailable, fullname, activityLevel, professions, rating } = user;
  const unavailableColorText = isAvailable ? colors.neutral['500'] : colors.neutral['300'];

  return (
    <Column justify="center" gap={1} style={detailsColumnStyle}>
      <Row align="center" gap={2}>
        <Typography as="span" bold size="heading_4" style={getTruncatedNameStyle(300, isAvailable)}>
          {fullname}
        </Typography>

        <Row align="center" justify="center" gap={2}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />
          <Box width="2px" height="20px" style={dividerStyle} />
          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={profileLinkStyle}>
              <Typography bold color={colors.secondary['500']} size="heading_4">
                Profile
              </Typography>
            </Link>
          ) : (
            <Typography bold color={colors.secondary['200']} size="heading_4">
              Profile
            </Typography>
          )}
        </Row>
      </Row>
      <Row align="center" gap={3}>
        <Typography color={unavailableColorText}>
          {UserProfession.getName(professions?.[0] || '')}
        </Typography>
        <Typography bold color={unavailableColorText}>
          • Activity Level:{' '}
          <Typography as="span" color={unavailableColorText} style={capitalizeStyle}>
            {activityLevel}
          </Typography>
        </Typography>
        {!isAvailable && (
          <Typography color={unavailableColorText}>• Currently Unavailable</Typography>
        )}
      </Row>
    </Column>
  );
};
